import { render, staticRenderFns } from "./writer2020.vue?vue&type=template&id=a8ab01d2&scoped=true&"
import script from "./writer2020.vue?vue&type=script&lang=js&"
export * from "./writer2020.vue?vue&type=script&lang=js&"
import style0 from "./writer2020.vue?vue&type=style&index=0&id=a8ab01d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ab01d2",
  null
  
)

export default component.exports